export default __webpack_public_path__ + "static/cover-3e890b038d6382f988d0996424fa0877.png";